import type { Snap } from '@/types/database.types';
import BaseSnapCard from './BaseSnapCard';

interface RegularSnapCardProps {
  snap: Snap & { activity: 'hot' | 'trending' | null };
  onDelete: (id: string) => void;
  onLike: (id: string, event: React.MouseEvent) => void;
  onVote?: (snapId: string, optionId: string) => void;
  onRemoveVote?: (snapId: string) => void;
  isVoting?: boolean;
}

export default function RegularSnapCard({ snap, onDelete, onLike, onVote, onRemoveVote, isVoting }: RegularSnapCardProps) {
  return (
    <BaseSnapCard
      snap={snap}
      onDelete={onDelete}
      onLike={onLike}
      onVote={onVote}
      onRemoveVote={onRemoveVote}
      isVoting={isVoting}
      wrapperClassName="relative bg-gradient-to-br from-white/25 to-white/15 backdrop-blur-sm border border-white/30 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden h-full flex flex-col"
    />
  );
}